import { OutlinedInput } from '@mui/material';
import React, { useEffect, useState } from 'react';
import Rupee from "../../../components/assets/Rupee.svg";
import LoadingSpinner from '../../../components/loader/LoadingSpinner';
import Modal from "../Modal/Modal";
import { NULL } from 'sass';
import CommonDatePicker from '../../CommonDatePicker';
import SalaryTimeline from '../../../components/employeeList/SalaryTimeline';
import AddRevised from '../../../components/employeeList/AddRevised';
import { useParams } from "react-router-dom";
import { GET_EMPLOYEE_SALARY } from "../../../components/utils";
import { getRequest, postRequest } from "../../../components/axiosClient";

const EmployeeFinances = ({ employeeData }) => {
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(false);
  const id = useParams();
  const [revisions, setrevisions] = useState([]);
  const formatSalary = (salary) => {
    return new Intl.NumberFormat("en-IN", {
      style: "decimal",
      maximumFractionDigits: 0,
    }).format(salary);
  };
  const formatMonthSalary = (salary) => {
    return `INR ${parseFloat(salary).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}`;
  };

  const formatDate = (date) => {
    const options = { year: "numeric", month: "short", day: "2-digit" };
    return new Date(date).toLocaleDateString("en-US", options);
  };
  // for get Employee salary API Call
  const GetEmployeeSalary = async () => {
    try {
      const res = await getRequest(
        `${GET_EMPLOYEE_SALARY}?user_id=${id?.id}`,
      );
      console.log(res.data.data);
      setrevisions(res.data.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    GetEmployeeSalary();
  }, [])

  return loading ? (
    <LoadingSpinner />
  ) : (
    <div className='my_team_time_sheet flex flex-col gap-3 h-full  pb-3'>
      {!show && <div className='flex flex-row justify-start px-3'>
        <button className="bg-[#267072] text-white w-fit  py-2 px-4 rounded-md text-16 cursor-pointer" onClick={() => setShow(!show)} >Revise</button>
      </div>}
      <div className="grow overflow-y-auto h-full">
        {show
          ? (<AddRevised employeeData={employeeData} show={show} setShow={setShow} revisions={revisions} formatSalary={formatSalary} formatDate={formatDate} GetEmployeeSalary={GetEmployeeSalary} />)
          : (<SalaryTimeline revisions={revisions} formatSalary={formatSalary} formatDate={formatDate} formatMonthSalary={formatMonthSalary} />)
        }
      </div>
    </div>
  )
}

export default EmployeeFinances